import {createReducer} from '@reduxjs/toolkit'
import _ from 'lodash'
import {closeAllEvents, toggleEventDetails} from '../actions/events'
import {MembersPageState} from '../types/state'

const defaultState: MembersPageState['expandedEvents'] = []

export const expandedEvents = createReducer(defaultState, builder => {
  builder
    .addCase(toggleEventDetails.fulfilled, (state, action) => {
      const eventId = action.payload
      if (state.includes(eventId)) {
        return _.without(state, eventId)
      } else {
        return [...state, eventId]
      }
    })
    .addCase(closeAllEvents, () => defaultState)
})
